<template>
  <div class="dialog_container">
    <el-dialog
      title="新增车牌号码变更信息"
      :visible="dialogShow"
      width="572px"
      @close="dialogClose"
      top="25vh"
      append-to-body
      :close-on-click-modal="false"
    >
      <div class="dialog_box">
        <el-form
          ref="redactForm"
          class="add_staff_form"
          :model="redactForm"
          label-width="160px"
          :rules="redactRules"
        >
          <el-form-item label="车牌号码：" prop="carNewNumber">
            <el-input
              placeholder="请输入车牌号码"
              v-model="redactForm.carNewNumber"
            ></el-input>
          </el-form-item>
          <el-form-item label="车辆颜色：" prop="carNewColor">
            <el-select v-model="redactForm.carNewColor" placeholder="请选择车辆颜色">
              <el-option
                v-for="item in carColorList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="注册（变更）日期：" prop="updateTimeStr">
            <el-date-picker
              v-model="redactForm.updateTimeStr"
              type="date"
              placeholder="请选择注册（变更）日期"
              :clearable="false"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input
              type="textarea"
              :autosize="{ minRows: 3 }"
              placeholder="请输入备注"
              v-model="redactForm.remark"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn" @click="dialogClose">取 消</el-button>
        <el-button class="btn btn_ok" @click="confirm('redactForm')">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { dateTransition } from "@/utils/util.js";
export default {
  name: "",
  data() {
    return {
      redactForm: {},
      carColorList: [],
      redactRules:{
        carNewNumber:[
          { required: true, message: "请输入车牌号码", trigger: "blur" },
        ],
        carNewColor:[
          { required: true, message: "请选择车辆颜色", trigger: "change" },
        ],
        updateTimeStr:[
          { required: true, message: "请选择注册（变更）日期", trigger: "change" },
        ],
      }
    };
  },
  components: {},
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
    carId:Number
  },
  watch:{
    dialogShow(val){
      if(val){
        console.log(this.carId);
        this.redactForm.carId = this.carId
        this.$http.getSelect(1).then((res) => {
        if (res.code == 0) {
          this.carColorList = res.data;
        } else {
          this.carColorList = [];
        }
      });
      }
    }
  },
  created() {},
  methods: {
    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return false;
        this.redactForm.updateTimeStr = dateTransition(this.redactForm.updateTimeStr)
        this.$http.carUpdateNumber(this.redactForm).then((res) => {
          if (res.code === 0) {
            this.$message.success(res.msg);
            this.$parent.getList();
            this.addForm = {};
            this.$emit("update:dialogShow", false);
          } else {
            this.$message.info(res.msg);
          }
        });
      });
    },
    dialogClose() {
      this.$emit("update:dialogShow", false);
    },
  },
};
</script>

<style lang="less" scoped>
@import "../redact";
/deep/.el-input__inner,
/deep/.el-textarea__inner {
  width: 352px;
}
.hint_box {
  width: 100%;
  display: flex;
  .hint_placeholder {
    width: 100px;
  }
  .hint_text {
    width: 250px;
    font-size: 11px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #9b9b9b;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/carAdmin/carTechnology_component/tabDialog/changeCarNumMes.vue